import { render, staticRenderFns } from "./port-owner-match-add.vue?vue&type=template&id=2f81dc51&"
import script from "./port-owner-match-add.vue?vue&type=script&lang=js&"
export * from "./port-owner-match-add.vue?vue&type=script&lang=js&"
import style0 from "./port-owner-match-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports